import { API_SYNC_TOTAL_CLICK } from 'routes/api'

import { _getApi } from './axios'

export const handleSyncTotalClick = () => {
  _getApi(API_SYNC_TOTAL_CLICK)
}
